import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import { X } from "lucide-react";

export default function FlashBanner() {
  const { settings } = useApp();
  const f = settings?.flash;
  const [closed, setClosed] = useState(false);
  if (!f?.enabled || !f.message) return null;
  const now = Date.now();
  if (f.start_at && now < new Date(f.start_at).getTime()) return null;
  if (f.end_at && now > new Date(f.end_at).getTime()) return null;
  if (closed) return null;
  return (
    <div data-testid="flash-banner" className="relative bg-[#C6531A] text-white text-center text-sm font-semibold px-10 py-2.5 leading-snug">
      <span>{f.message}</span>
      {f.cta_url && f.cta_label && (
        <a href={f.cta_url} className="underline underline-offset-2 ml-2 font-bold hover:opacity-90">{f.cta_label}</a>
      )}
      <button data-testid="flash-banner-close" onClick={() => setClosed(true)} aria-label="Fermer" className="absolute right-3 top-1/2 -translate-y-1/2 opacity-80 hover:opacity-100">
        <X size={16} />
      </button>
    </div>
  );
}
